"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Overlay = exports.useOverlayRoot = void 0;
var react_1 = require("react");
var react_dom_1 = require("react-dom");
var useOverlayRoot = function () { return document.getElementById("overlay-root"); };
exports.useOverlayRoot = useOverlayRoot;
var Overlay = function (_a) {
    var children = _a.children;
    var overlayRoot = (0, exports.useOverlayRoot)();
    var el = (0, react_1.useRef)(document.createElement("div"));
    (0, react_1.useEffect)(function () {
        overlayRoot === null || overlayRoot === void 0 ? void 0 : overlayRoot.appendChild(el.current);
        return function () {
            overlayRoot === null || overlayRoot === void 0 ? void 0 : overlayRoot.removeChild(el.current);
        };
    });
    return (0, react_dom_1.createPortal)(children, el.current);
};
exports.Overlay = Overlay;
